import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { RelazioneAtlante } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesRelazione, validationSchemaRelazione } from "./RelazioneAtlanteCommon"
import FormatoForm from "./RelazioneAtlanteForm"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"
import { useRelazioneAtlanteCreate } from "../../hooks/relazioniAtlante"

export default function RelazioniAtlanteCreate() {
  const createRelazione = useRelazioneAtlanteCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Relazioni Atlante", href: "/atlanti/relazioni" }, { label: "Creazione Relazione Atlante" }])

  const initialValues = useMemo(() => initialValuesRelazione(), [])
  const validationSchema = useMemo(() => validationSchemaRelazione(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova Relazione Atlante</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createRelazione
                .mutateAsync(values as RelazioneAtlante)
                .then((relazione) => {
                  navigate(`/atlanti/relazioni/${relazione.id}`)
                })
                .catch((e) => {
                  actions.setErrors(transformErrorForForm(e))
                })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <FormatoForm />
                </Container>
                <BottomFormFixed url="/atlanti/relazioni" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
